import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"

import ThemeConsumer from "shared/components/ThemeConsumer"

const ContainerView = ({ theme, children, classNames }) => {
  const containerViewClasses = classnames(
    theme.mt6,
    theme.p4,
    theme.containerDescription,
    classNames
  )
  return <section className={containerViewClasses}>{children}</section>
}

ContainerView.propTypes = {
  theme: PropTypes.shape({
    mt6: PropTypes.string,
    p4: PropTypes.string,
    containerDescription: PropTypes.string
  }),
  children: PropTypes.node.isRequired,
  classNames: PropTypes.string
}

export default ThemeConsumer("UICustomerRegister")(ContainerView)



// WEBPACK FOOTER //
// ./src/scenes/Customer/components/ContentView/index.js